<script>
    // import { tourConfig as PromiseConfig } from '../tour-config';
    // const tourConfig = Promise.resolve(PromiseConfig);
    export let config;
    const tourConfig = config;

    import { onMount } from 'svelte';
    import Loader from './Loader.svelte'

    export let xml;
    export let logo = './images/logo.png';
    export let logoWidth = 500;

    let krpano;
    window.CC = window.CC || {}
    let krpanoLoading = true;

    function setKrpano(krpanoHandle){
        krpano = krpanoHandle;
        window.CC.krpano = krpano;
    }

    function startKrpano(){
      if (typeof embedpano === "function") { 
        embedpano({
            xml: xml,
            target:"pano",
            html5:"always",
            passQueryParameters:true,
            onready: setKrpano,
            initvars: {
              hotspotHoverColor: tourConfig.colors.hotspotHoverColor,
              calloutColor: tourConfig.colors.calloutColor,
            }
        });
          
        krpanoLoading = false;
        return true;
      } else {
          return false;
      }
    }

    onMount(async () => {
      if(xml){
        // check if the embedpano function exists, and call it when it does.
        let interval = setInterval(()=>{
            if(startKrpano()){
                clearInterval(interval);
            }
        }, 1000);
      }
    });
</script>

<!-- /*____________ Markup ____________*/ -->
<svelte:head>
  <script src={'tour.js'} />
</svelte:head>

<Loader logo={logo} loading={krpanoLoading} delay="1500" width={logoWidth}/>
<div id="pano" class="tour"></div>

<!-- /*____________ CSS ____________*/ -->
<style>
div.tour {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #000;
}
</style>
